import { Injectable } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { emailsValidator, IFormBuilder } from "@dffedb/forms";
import { ValgtInstallationService } from "@e-forsyning/common/valgt-installation/valgt-installation.service";

import { KontaktoplysningerPopupContentModel } from "./kontaktoplysninger-popup-content.model";
import { KontaktoplysningerPopupContentViewModel } from "./kontaktoplysninger-popup-content.view-model";

@Injectable({ providedIn: "root" })
export class KontaktoplysningerPopupContentSandbox {
    private readonly fb: IFormBuilder;

    constructor(fb: UntypedFormBuilder, private readonly valgtInstallationService: ValgtInstallationService) {
        this.fb = fb;
    }

    public hentViewModel(): Observable<KontaktoplysningerPopupContentViewModel> {
        const result = this.valgtInstallationService.hentInstallationsoplysninger().pipe(
            map((i) => ({
                formGroup: this.fb.group<KontaktoplysningerPopupContentModel>({
                    telefonnr: this.fb.control(i.telefonnr),
                    beboeremail: this.fb.control(i.beboeremail, [emailsValidator(",")])
                })
            }))
        );
        return result;
    }

    public async gem(value: KontaktoplysningerPopupContentModel): Promise<void> {
        await this.valgtInstallationService.redigerBeboeremail(value.beboeremail);
        await this.valgtInstallationService.redigerTelefonnr(value.telefonnr);
    }
}
